import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { BannerTemplate } from '../../CustomerPrivacyAndSecurityTab/CustomerPrivacyAndSecurityTab.styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const PrivacySecurityDetailsNotAvailableBanner = _ref => {
  let {
    isHostingCloud
  } = _ref;
  return /*#__PURE__*/_jsx(BannerTemplate, {
    children: isHostingCloud ? /*#__PURE__*/_jsx(SectionMessage, {
      title: "This app is owned and maintained by Atlassian.",
      appearance: "information",
      children: /*#__PURE__*/_jsxs("p", {
        children: ["For privacy and security information on Atlassian created apps please see the Atlassian", /*#__PURE__*/_jsxs(ExternalLink, {
          href: "https://www.atlassian.com/legal/data-processing-addendum",
          children: [' ', "Customer DPA", ' ']
        }), "and ", /*#__PURE__*/_jsx(ExternalLink, {
          href: "https://www.atlassian.com/trust",
          children: "Trust Center"
        }), "."]
      })
    }) : /*#__PURE__*/_jsx(SectionMessage, {
      title: "Privacy & Security details not available",
      appearance: "information",
      actions: [/*#__PURE__*/_jsx(SectionMessageAction, {
        href: "https://developer.atlassian.com/platform/marketplace/security-privacy-tab/#how-will-you-provide-the-information-for-your-apps-",
        children: "Learn how we collect this information"
      }, "how-will-you-provide-the-information-for-your-apps")],
      children: /*#__PURE__*/_jsx("p", {
        children: "The newly introduced Privacy and Security tab displays information only for cloud apps, which is collected from the respective app partner. It does not apply for server and data center apps."
      })
    })
  });
};
export default PrivacySecurityDetailsNotAvailableBanner;